module.exports = __webpack_public_path__ + "img/big.e544f9fb.jpg";